import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgInjuredDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgInjured = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <mask
      id="mask0_injured"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="16"
      height="14"
    >
      <path d="M16 1.26328H0V14.737H16V1.26328Z" fill="white" />
    </mask>
    <g mask="url(#mask0_injured)">
      <path d="M14.1128 13.8273L8.17546 3.36621L1.78564 13.8273H14.1128Z" fill="white" />
      <path
        d="M0.280762 14.7368L8.00006 1.40341L15.7194 14.7368H0.280762ZM2.70181 13.3333H13.2983L8.00006 4.21042L2.70181 13.3333ZM8.00006 12.6315C8.1989 12.6315 8.36554 12.5642 8.5001 12.4297C8.63458 12.2953 8.70186 12.1286 8.70186 11.9297C8.70186 11.7309 8.63458 11.5642 8.5001 11.4297C8.36554 11.2953 8.1989 11.228 8.00006 11.228C7.80123 11.228 7.63456 11.2953 7.50006 11.4297C7.36556 11.5642 7.29831 11.7309 7.29831 11.9297C7.29831 12.1286 7.36556 12.2953 7.50006 12.4297C7.63456 12.5642 7.80123 12.6315 8.00006 12.6315ZM7.29831 10.5262H8.70186V7.01744H7.29831V10.5262Z"
        fill="#EB1701"
      />
    </g>
  </svg>
));
